import React, { useState, useMemo } from 'react';
import { Link } from '@jutro/components';

function useSgExpandableSection(props) {
    const {
        id,
        content,
        showMoreLabel,
        showLessLabel,
        openOnInit,
        showLinkAdobeValue,
        hideLinkAdobeValue
    } = props;

    const showMoreText = showMoreLabel;
    const showLessText = showLessLabel;
    const [isExpanded, setIsExpanded] = useState(openOnInit || false);

    const linkAdobeValue = useMemo(() => {
        if (showLinkAdobeValue && hideLinkAdobeValue) {
            return isExpanded ? hideLinkAdobeValue : showLinkAdobeValue;
        }
        return undefined;
    }, [showLinkAdobeValue, hideLinkAdobeValue, isExpanded]);

    const toggleExpanded = (event) => {
        if (event) {
            event.preventDefault();
        }
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            <div className="sgMoreInformationLinkContainer">
                <Link
                    href="/"
                    id={`showMore${id}`}
                    adobeValue={linkAdobeValue}
                    onClick={toggleExpanded}
                    onContextMenu={(e) => e.preventDefault()}
                >
                    {isExpanded ? showLessText : showMoreText}
                </Link>
            </div>
            <div id={`content_${id}`} className={`${isExpanded ? 'sgMoreInformationContent' : ''}`}>
                {isExpanded && content}
            </div>
        </>
    );
}

export default useSgExpandableSection;
